import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { BackrsIcon } from './BackrsIcon';
import { appColors } from '../assets/appColors';
var ICON_SIZE = 24;
export var BackrsIconRow = function (_a) {
    var id = _a.id, icon = _a.icon, text = _a.text, onClick = _a.onClick;
    return (_jsxs(Box, { id: id, sx: iconRowStyle, onClick: onClick, children: [_jsx(BackrsIcon, { name: icon, alt: text, color: appColors.color.blue1, width: ICON_SIZE, height: ICON_SIZE }), _jsx(Typography, { sx: typographyStyle, children: text })] }));
};
var iconRowStyle = {
    cursor: 'pointer',
    gap: 2,
    flexDirection: 'row',
    display: 'flex',
};
var typographyStyle = {
    fontSize: '12pt',
    fontWeight: 'bold',
    color: appColors.color.blue1,
    '@media (max-width: 756px)': {
        fontSize: '12pt',
    },
};
